import React, { createContext, useContext, useEffect, useState } from "react";
import Layout from "../components/layout";
import SEO from "../components/seo";
import PageSectionContainer from "../components/common/page-section-container";
import PageSectionHeading from "../components/common/page-section-heading";
import Img from "gatsby-image";
import AuthorNames from "../components/author-names";
import MagazineActions from "../components/magazine/actions";
import { useLatestMagazine } from "../hooks/use-latest-magazine";
import MagazineBuy, { MagazineBuyState } from "../components/magazine/buy";
import LoginPopup from "../components/common/login-popup";
import { magazineAccess } from "../services/monsum/magazines/access";
import AuthContext from "../services/firebase/auth-context/provider";
import IPBasedLoginContext from "../services/ip-based-login/provider";
export var LoginPopupContext = /*#__PURE__*/ createContext({
    loginPopupStatus: false,
    onLoginClick: function onLoginClick() { }
});
var Magazine = function Magazine(_ref) {
    var _useLatestMagazine;
    var data = _ref.data, location = _ref.location;
    var authenticated = useContext(AuthContext)[0].authenticated;
    var _useState = useState(MagazineBuyState.INACTIVE), buyState = _useState[0], setBuyState = _useState[1];
    var _useState2 = useState(false), loginPopupStatus = _useState2[0], setPopupStatus = _useState2[1];
    var _useState3 = useState({
        hasAccess: false,
        hasActiveSubscription: false,
        hasPremiumSubscription: false,
        downloadUrl: ""
    }), access = _useState3[0], setAccess = _useState3[1];
    var ipbl = useContext(IPBasedLoginContext);
    var checkAccess = function checkAccess() {
        magazineAccess(magazine.number, magazine.pdfFile).then(function (res) {
            return evaluateAccessResult(res);
        }).catch(function (err) {
            return console.error("Failed to load magazine access state", err);
        });
        var evaluateAccessResult = function evaluateAccessResult(res) {
            if (res && res.data) {
                setAccess({
                    hasAccess: res.data.hasAccess,
                    hasActiveSubscription: res.data.hasActiveSubscription,
                    hasPremiumSubscription: res.data.hasPremiumSubscription,
                    downloadUrl: res.data.downloadUrl
                });
            }
        };
    };
    useEffect(function () {
        checkAccess();
    }, []);
    useEffect(function () {
        checkAccess();
    }, [authenticated]);
    var magazine = data.datoCmsMagazine;
    var description = magazine.description ? magazine.description : magazine.shortDescriptionOverview;
    var isLatestMagazine = magazine.number == ((_useLatestMagazine = useLatestMagazine()) === null || _useLatestMagazine === void 0 ? void 0 : _useLatestMagazine.number);
    var action = buyState !== MagazineBuyState.INACTIVE ? /*#__PURE__*/ React.createElement(MagazineBuy, {
        number: magazine.number,
        price: magazine.price,
        soldOut: magazine.soldOut,
        onlyDigital: magazine.onlyDigital,
        setBuyState: setBuyState
    }) : /*#__PURE__*/ React.createElement(MagazineActions, {
        price: magazine.price,
        soldOut: magazine.soldOut,
        onlyDigital: magazine.onlyDigital,
        isLatestMagazine: isLatestMagazine,
        setBuyState: setBuyState,
        access: access
    });
    var onlyDigitalAndHasAccess = magazine.onlyDigital && (access.hasAccess || access.hasActiveSubscription && access.hasPremiumSubscription || ipbl);
    return /*#__PURE__*/ React.createElement(Layout, {
        location: location
    }, /*#__PURE__*/ React.createElement(SEO, {
        title: magazine.title
    }), /*#__PURE__*/ React.createElement(LoginPopupContext.Provider, {
        value: {
            loginPopupStatus: loginPopupStatus,
            onLoginClick: function onLoginClick() {
                return setPopupStatus(true);
            }
        }
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-wrap pb-8 justify-center"
    }, /*#__PURE__*/ React.createElement(PageSectionContainer, null, /*#__PURE__*/ React.createElement(PageSectionHeading, {
        className: "mb-4",
        title: magazine.label
    }), /*#__PURE__*/ React.createElement("div", {
        className: "px-3 lg:pl-8 " + (onlyDigitalAndHasAccess ? "lg-pr-8" : "lg:pr-12")
    }, /*#__PURE__*/ React.createElement("h1", {
        className: "text-3xl leading-tight mb-4 md:text-4xl article-title"
    }, magazine.title), /*#__PURE__*/ React.createElement(AuthorNames, {
        authors: magazine.authors,
        isMagazine: true,
        className: "inline-block"
    }), onlyDigitalAndHasAccess ? /*#__PURE__*/ React.createElement("div", {
        className: "mt-6"
    }, /*#__PURE__*/ React.createElement("div", {
        dangerouslySetInnerHTML: {
            __html: magazine.fliphtml5EmbedCode
        }
    })) : /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-wrap mt-6"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "w-full sm:pr-4 sm:w-2/3 md:pr-6 md:w-1/2 lg:pr-8 lg:w-3/5"
    }, action, /*#__PURE__*/ React.createElement("div", {
        className: "content-text",
        dangerouslySetInnerHTML: {
            __html: description
        }
    }), magazine.numberSites && /*#__PURE__*/ React.createElement("div", {
        className: "content-text mt-4 font-medium"
    }, "Anzahl Seiten: ", magazine.numberSites), magazine.extract && /*#__PURE__*/ React.createElement("a", {
        target: "_blank",
        rel: "noopener noreferrer",
        href: magazine.extract.url,
        className: "inline-block text-white border-2 border-solid border-makroPurple bg-makroPurple px-4 py-2 mt-5 hover:text-makroPurple hover:bg-white"
    }, "\xBB Leseprobe \xF6ffnen")), /*#__PURE__*/ React.createElement("div", {
        className: "w-full sm:w-1/3 md:w-1/2 lg:w-2/5"
    }, /*#__PURE__*/ React.createElement(Img, {
        fluid: magazine.image.fluid,
        className: "shadow-magazines"
    })), /*#__PURE__*/ React.createElement("div", {
        className: "w-full mt-8"
    }, magazine.extractFliphtml5EmbedCode && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: "font-medium content-text inline-block mb-2"
    }, "Leseprobe"), /*#__PURE__*/ React.createElement("div", {
        dangerouslySetInnerHTML: {
            __html: magazine.extractFliphtml5EmbedCode
        }
    })))))))), /*#__PURE__*/ React.createElement(LoginPopup, {
        shouldShowPopup: loginPopupStatus,
        onClose: function onClose() {
            return setPopupStatus(false);
        }
    }));
};
var query = "436682181";
export default Magazine;
